import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const SignUp = lazy(() => import('@pages/dashboard/SignUp/index'));
const AffiliateSignUp = lazy(
  () => import('@pages/dashboard/SignUp/AffiliateSignUp'),
);

const SignUpRoutes: RouteObject[] = [
  {
    path: '/sign-up',
    element: (
      <React.Suspense>
        <SignUp />
      </React.Suspense>
    ),
    children: [],
  },
  {
    path: '/signup/affiliate',
    element: (
      <React.Suspense>
        <AffiliateSignUp />
      </React.Suspense>
    ),
  },
];

export default SignUpRoutes;
